import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { getDefaultForm } from "../../../core/common/formSelection";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Table from "../../../core/common/dataTable/index";
import api from "../../../services/api";
import { showBasicAlert } from "../../../core/common/useAlert";
import jsPDF from "jspdf";
import { DatePicker, Select, TreeSelect } from "antd";
import * as XLSX from "xlsx";
import AddLeads from "./addLeads";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import CommonSelect from "../../../core/common/commonSelect";
import {
  Menu,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import LeadsGridFilters from "./components/LeadsGridFilters";
import { SlidersHorizontal } from "lucide-react";

import EditIcon from "@mui/icons-material/Edit";
import EditLead from "./editLead";
import { humanReadableDate } from "../../../helper/dateTimeHelper";
import ReminderDropdown from "./components/ReminderDropdown";

interface FormField {
  id: string;
  label: string;
  type: "text" | "select";
  options?: string[];
}

interface FormData {
  structure: FormField[];
  responses?: { [key: string]: string };
}

const LeadsList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user.user);

  const previousSelectedCompanyDetails = location.state?.companyDetails || null;
  const previousSelectedformDetails = location.state?.formDetails || null;

  const { Option } = Select;
  const signature = localStorage.getItem("signature");
  const routes = all_routes;

  // ✅ Split loading states
  const [isInitializing, setIsInitializing] = useState(true);
  const [isLoadingData, setIsLoadingData] = useState(false);

  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [lastLeadDetail, setLastLeadDeail] = useState<any[]>([]);

  const [getAllCompanyLists, setgetAllCompanyList] = useState<any[]>([]);
  const [getAllCompanyListsForAdd, setgetAllCompanyListForAdd] = useState<
    any[]
  >([]);
  const [dataForm, setdataForm] = useState<any[]>([]);
  const [pipelines, setPipelines] = useState<any[]>([]);

  const [HeaderGrid, setHeaderGrid] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);

  // Filter states
  const [selectedLeadSource, setSelectedLeadSource] = useState<
    string | undefined
  >(undefined);
  const [selectedStartDate, setSelectedStartDate] = useState<moment.Moment>(
    moment().subtract(29, "days"),
  );
  const [selectedEndDate, setSelectedEndDate] =
    useState<moment.Moment>(moment());
  const [sortBy, setSortBy] = useState<string>("Recently Added");

  // Edit/Menu states
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState<FormData | null>(null);

  const [showFilters, setShowFilters] = useState(false);
  const [showOnlyTransferred, setShowOnlyTransferred] = useState(false);
  const [transferLeadsId, setTransferLeadsId] = useState<any[]>([]);

  const [activityFilter, setActivityFilter] = useState<string>("all");
  const [activityStartDate, setActivityStartDate] = useState<moment.Moment>(
    moment().subtract(29, "days"),
  );
  const [activityEndDate, setActivityEndDate] =
    useState<moment.Moment>(moment());
  const [activityLeadIds, setActivityLeadIds] = useState<number[] | null>(null);
  const [isActivityLoading, setIsActivityLoading] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [tempSearchQuery, setTempSearchQuery] = useState("");

  const [showReminderModal, setShowReminderModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
  const [selectedReminderDate, setSelectedReminderDate] = useState<any>(null);
  const [followUpFilter, setFollowUpFilter] = useState<string>("all"); // "all", "today", "overdue", "upcoming", "custom", "none"
  const [customFollowUpDate, setCustomFollowUpDate] =
    useState<moment.Moment | null>(null);
  const [filterKey, setFilterKey] = useState(0);

  const [reminderLeadIds, setReminderLeadIds] = useState<{
    today: number[];
    overdue: number[];
    upcoming: number[];
  } | null>(null);
  const [reminderLeads, setReminderLeads] = useState<{
    today: any[];
    overdue: any[];
    upcoming: any[];
  } | null>(null);
  const [isReminderLoading, setIsReminderLoading] = useState(false);
  const [reminderDropdownOpened, setReminderDropdownOpened] = useState(false);
  const [reminderCustomStart, setReminderCustomStart] =
    useState<moment.Moment | null>(null);
  const [reminderCustomEnd, setReminderCustomEnd] =
    useState<moment.Moment | null>(null);
  // Track whether reminder data has been fetched for the current form — prevents re-fetch on every tab switch
  const reminderLoadedForFormRef = useRef<string>("");

  const followUpOptions = [
    { value: "today", label: "Today" },
    { value: "upcoming", label: "Upcoming" },
    { value: "overdue", label: "Overdue" },
  ];

  const activityFilterOptions = [
    { value: "all", label: "All Activity" },
    { value: "today", label: "Today's Activity" },
    { value: "yesterday", label: "Yesterday's Activity" },
    { value: "custom", label: "Custom Date" },
  ];

  const [formDataCompanyChoose, setformDataCompanyChoose] = useState({
    companyName: "Select Company",
    companyId: "",
    companyType: "Leads",
  });

  const [formDataFormChoose, setformDataFormChoose] = useState({
    pipeline_id: "",
    form_name: "",
    form_id: "",
    user_id: "0",
    user_name: "All Employees",
    pipeline_value: "0",
    pipeline_char: "All Pipelines",
  });

  // Refs for debouncing and preventing duplicate calls
  const prevFetchParamsRef = useRef<string>("");
  const filterDebounceRef = useRef<NodeJS.Timeout | null>(null);
  const isRestoringFromPreserve = useRef(false);
  const locationStateRef = useRef(location.state);

  const leadSource = [
    {
      value: "Direct Calling",
      title: "Direct Calling",
      children: [
        { value: "Outbound Call (Manual)", title: "Outbound Call (Manual)" },
        { value: "Inbound Call", title: "Inbound Call" },
        { value: "Inbound via Campaign", title: "Inbound via Campaign" },
      ],
    },
    {
      value: "Messaging & Campaigns",
      title: "Messaging & Campaigns",
      children: [
        { value: "SMS Campaign", title: "SMS Campaign" },
        { value: "WhatsApp Campaign", title: "WhatsApp Campaign" },
      ],
    },
    {
      value: "Referrals",
      title: "Referrals",
      children: [
        { value: "Wholesaler/Distributor", title: "Wholesaler/Distributor" },
        { value: "Past Student Referral", title: "Past Student Referral" },
        { value: "Society Referral", title: "Society Referral" },
        { value: "Department Referral", title: "Department Referral" },
        { value: "Helpdesk", title: "Helpdesk" },
      ],
    },
    {
      value: "Social Media",
      title: "Social Media",
      children: [
        { value: "Facebook", title: "Facebook" },
        { value: "Instagram", title: "Instagram" },
        { value: "WhatsApp", title: "WhatsApp" },
      ],
    },
    {
      value: "Public Form",
      title: "Public Form",
    },
  ];

  // ✅ Helper function to determine if selected value is parent or child
  const getLeadSourceFilter = useCallback(() => {
    if (!selectedLeadSource) return {};
    const parentValues = leadSource.map((item) => item.value);
    return parentValues.includes(selectedLeadSource)
      ? { parent_source: selectedLeadSource }
      : { child_source: selectedLeadSource };
  }, [selectedLeadSource]);

  const calculateActiveFilters = () => {
    let count = 0;
    if (selectedLeadSource) count++;
    if (formDataFormChoose.user_id !== "0") count++;
    if (formDataFormChoose.pipeline_value !== "0") count++;
    if (followUpFilter !== "all") count++;
    if (customFollowUpDate) count++;
    if (searchQuery) count++;
    if (showOnlyTransferred) count++;

    const defaultStartDate = moment().subtract(29, "days").format("YYYY-MM-DD");
    const defaultEndDate = moment().format("YYYY-MM-DD");
    const currentStartDate = selectedStartDate.format("YYYY-MM-DD");
    const currentEndDate = selectedEndDate.format("YYYY-MM-DD");
    if (
      currentStartDate !== defaultStartDate ||
      currentEndDate !== defaultEndDate
    ) {
      count++;
    }
    if (activityFilter !== "all") count++;
    if (tempSearchQuery) count++;
    return count;
  };

  // Add this function after your other filter functions
  const filterByFollowUp = useCallback(
    (lead: any) => {
      if (followUpFilter === "all") return true;

      const followUpDate = lead.follow_up_date;

      if (!followUpDate) {
        return followUpFilter === "none";
      }

      if (followUpFilter === "none") return false;

      if (
        reminderLeadIds &&
        ["today", "overdue", "upcoming"].includes(followUpFilter)
      ) {
        const leadId = Number(lead.key || lead.id);
        if (followUpFilter === "today")
          return reminderLeadIds.today.includes(leadId);
        if (followUpFilter === "overdue")
          return reminderLeadIds.overdue.includes(leadId);
        if (followUpFilter === "upcoming")
          return reminderLeadIds.upcoming.includes(leadId);
      }

      const leadMoment = moment(followUpDate);
      const leadLocal = leadMoment.local();
      const leadDateStr = leadLocal.format("YYYY-MM-DD");

      switch (followUpFilter) {
        case "today":
          const todayStr = moment().format("YYYY-MM-DD");
          return leadDateStr === todayStr;

        case "upcoming":
          return leadLocal.isAfter(moment().endOf("day"));

        case "overdue":
          return leadLocal.isBefore(moment().startOf("day"));

        // case "custom":
        //   if (!customFollowUpDate) return true;
        //   const customDateStr = customFollowUpDate.format("YYYY-MM-DD");
        //   return leadDateStr === customDateStr;

        case "custom":
          if (!reminderCustomStart || !reminderCustomEnd) return true;
          const leadMomentCheck = moment(followUpDate).local();
          return (
            leadMomentCheck.isSameOrAfter(reminderCustomStart, "day") &&
            leadMomentCheck.isSameOrBefore(reminderCustomEnd, "day")
          );

        default:
          return true;
      }
    },
    [followUpFilter, customFollowUpDate, reminderLeadIds],
  );

  const handleClearAllFilters = () => {
    isRestoringFromPreserve.current = false;
    locationStateRef.current = null;

    setSelectedLeadSource(undefined);
    setSelectedStartDate(moment().subtract(29, "days"));
    setSelectedEndDate(moment());
    setFollowUpFilter("all");
    setCustomFollowUpDate(null);
    setShowOnlyTransferred(false);
    setActivityFilter("all");
    setActivityStartDate(moment().subtract(29, "days"));
    setActivityEndDate(moment());
    setActivityLeadIds(null);
    setSearchQuery("");
    setTempSearchQuery("");
    setSearchInput("");
    setSortBy("Recently Added");
    setFilterKey((prev) => prev + 1);
    prevFetchParamsRef.current = "";

    setformDataFormChoose((prev) => ({
      ...prev,
      user_id: "0",
      user_name: "All Employees",
      pipeline_value: "0",
      pipeline_char: "All Pipelines",
    }));

    setTimeout(() => {
      isRestoringFromPreserve.current = false;
    }, 100);
  };

  const handleActivityFilterChange = (option: any) => {
    setActivityFilter(option.value);
  };

  const handleActivityDateChange = (
    start: moment.Moment,
    end: moment.Moment,
  ) => {
    setActivityStartDate(start);
    setActivityEndDate(end);
  };

  const handleSearchApply = useCallback(() => {
    setSearchQuery(tempSearchQuery);
  }, [tempSearchQuery]);

  const [activeFilterCount, setActiveFilterCount] = useState<number>(0);

  // ✅ 1. Fetch companies on mount (page loader)
  useEffect(() => {
    fetchCompanies();
  }, []);

  // ✅ 2. When companies load, set default company
  useEffect(() => {
    if (getAllCompanyLists.length) {
      const defaultCompany =
        previousSelectedCompanyDetails || getAllCompanyLists[0];
      if (defaultCompany) {
        setformDataCompanyChoose({
          companyId:
            previousSelectedCompanyDetails?.companyId || defaultCompany.id,
          companyName:
            previousSelectedCompanyDetails?.companyName || defaultCompany.name,
          companyType:
            previousSelectedCompanyDetails?.companyType || defaultCompany.type,
        });
      }
    }
  }, [getAllCompanyLists]);

  // ✅ 3. When company changes, fetch forms (section loader)
  useEffect(() => {
    if (formDataCompanyChoose.companyId) {
      fetchForms();
    }
  }, [formDataCompanyChoose.companyId, formDataCompanyChoose.companyType]);

  // ✅ 4. When forms load, set default form
  useEffect(() => {
    if (isRestoringFromPreserve.current) return;
    if (dataForm.length && formDataCompanyChoose.companyId) {
      const defaultForm =
        previousSelectedformDetails || getDefaultForm(dataForm);
      if (defaultForm) {
        setformDataFormChoose((prev) => ({
          ...prev,
          pipeline_id:
            previousSelectedformDetails?.pipeline_id || defaultForm.pipeline_id,
          form_name:
            previousSelectedformDetails?.form_name || defaultForm.LeadFormName,
          form_id: previousSelectedformDetails?.form_id || defaultForm.key,
          user_id: previousSelectedformDetails?.user_id || "0",
          user_name: previousSelectedformDetails?.user_name || "All Employees",
        }));
      }
    } else if (dataForm.length === 0) {
      setformDataFormChoose((prev) => ({
        ...prev,
        pipeline_id: "",
        form_name: "No Lead Form",
        form_id: "",
        user_id: "0",
        user_name: "All Employees",
      }));
    }
  }, [dataForm]);

  // ✅ Reset reminder cache ONLY when form changes (not on every filter change)
  useEffect(() => {
    if (!formDataFormChoose.form_id) return;
    reminderLoadedForFormRef.current = "";
    setReminderLeadIds(null);
    setReminderLeads(null);
  }, [formDataFormChoose.form_id]);

  // ✅ 5. When form/filters change, fetch leads (debounced)
  useEffect(() => {
    if (!formDataFormChoose.form_id) return;

    if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);

    filterDebounceRef.current = setTimeout(() => {
      fetchLeads();
    }, 500);

    return () => {
      if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
    };
  }, [
    formDataFormChoose.form_id,
    formDataFormChoose.user_id,
    formDataFormChoose.pipeline_value,
    selectedLeadSource,
    selectedStartDate,
    selectedEndDate,
    followUpFilter,
  ]);

  // ✅ Update active filter count
  useEffect(() => {
    setActiveFilterCount(calculateActiveFilters());
  }, [
    selectedLeadSource,
    formDataFormChoose.user_id,
    formDataFormChoose.pipeline_value,
    selectedStartDate,
    selectedEndDate,
    followUpFilter,
  ]);

  useEffect(() => {
    if (!location.state?.preserveFilters) return;

    isRestoringFromPreserve.current = true;
    const p = location.state.preserveFilters;

    setformDataCompanyChoose({
      companyId: p.companyId,
      companyName: p.companyName,
      companyType: p.companyType,
    });
    setformDataFormChoose({
      pipeline_id: p.pipeline_id,
      form_name: p.form_name,
      form_id: p.form_id,
      user_id: p.user_id,
      user_name: p.user_name,
      pipeline_value: p.pipeline_value,
      pipeline_char: p.pipeline_char,
    });
    setSelectedLeadSource(p.selectedLeadSource);
    setSelectedStartDate(moment(p.selectedStartDate));
    setSelectedEndDate(moment(p.selectedEndDate));
    setSortBy(p.sortBy || "Recently Added");
    setFollowUpFilter(p.followUpFilter || "all");
    setCustomFollowUpDate(
      p.customFollowUpDate ? moment(p.customFollowUpDate) : null,
    );
    setShowOnlyTransferred(p.showOnlyTransferred || false);
    setSearchQuery(p.searchQuery || "");
    setSearchInput(p.searchInput || "");
    setActivityFilter(p.activityFilter || "all");
    setActivityStartDate(
      p.activityStartDate
        ? moment(p.activityStartDate)
        : moment().subtract(29, "days"),
    );
    setActivityEndDate(
      p.activityEndDate ? moment(p.activityEndDate) : moment(),
    );
    setTempSearchQuery(p.tempSearchQuery || "");
    setShowFilters(p.showFilters || false);
    setFilterKey((prev) => prev + 1);

    // Reset flag after state updates
    setTimeout(() => {
      isRestoringFromPreserve.current = false;
    }, 100);

    // ← Immediately wipe preserveFilters from location state after reading it
    navigate(
      { pathname: location.pathname, search: location.search },
      { replace: true, state: null },
    );
  }, []);
  useEffect(() => {
    locationStateRef.current = location.state;
  }, [location.state]);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(
        { pathname: location.pathname, search: location.search },
        { replace: true, state: null },
      );
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // ========== API FUNCTIONS ==========

  useEffect(() => {
    const fetchActivityLeadIds = async () => {
      if (activityFilter === "all") {
        setActivityLeadIds(null);
        return;
      }

      if (
        activityFilter === "custom" &&
        (!activityStartDate || !activityEndDate)
      ) {
        return;
      }

      try {
        setIsActivityLoading(true);
        let startDateStr = "";
        let endDateStr = "";

        if (activityFilter === "today") {
          startDateStr = moment().startOf("day").format("YYYY-MM-DD");
          endDateStr = moment()
            .add(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        } else if (activityFilter === "yesterday") {
          startDateStr = moment()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
          endDateStr = moment().startOf("day").format("YYYY-MM-DD");
        } else if (
          activityFilter === "custom" &&
          activityStartDate &&
          activityEndDate
        ) {
          startDateStr = activityStartDate.format("YYYY-MM-DD");
          endDateStr = moment(activityEndDate)
            .add(1, "days")
            .format("YYYY-MM-DD");
        }

        const response = await api.post(`leadService/getLeadIdsByActivity`, {
          signature,
          company_id: formDataCompanyChoose.companyId,
          company_type: formDataCompanyChoose.companyType,
          form_id: formDataFormChoose.form_id,
          activity_start_date: startDateStr,
          activity_end_date: endDateStr,
        });

        if (
          response.data?.msg === "Data Found" &&
          response.data?.data?.lead_ids
        ) {
          setActivityLeadIds(response.data.data.lead_ids);
        } else {
          setActivityLeadIds([]);
        }
      } catch (error) {
        console.error("Error fetching activity lead IDs:", error);
        setActivityLeadIds([]);
      } finally {
        setIsActivityLoading(false);
      }
    };

    if (formDataCompanyChoose.companyId && formDataFormChoose.form_id) {
      fetchActivityLeadIds();
    }
  }, [
    activityFilter,
    activityStartDate,
    activityEndDate,
    formDataCompanyChoose,
    formDataFormChoose.form_id,
    signature,
  ]);

  useEffect(() => {
    const fetchReminderLeadIds = async () => {
      if (!reminderDropdownOpened) return;
      if (!formDataFormChoose.form_id) return;

      try {
        setIsReminderLoading(true);
        const response = await api.post("leadService/getLeadReminder", {
          signature,
          company_id: formDataCompanyChoose.companyId,
          company_type: formDataCompanyChoose.companyType,
          form_id: formDataFormChoose.form_id,
          limit: 100000,
        });
        if (
          response.data?.message?.message === "Data Found" &&
          response.data?.message?.reminder
        ) {
          const { today, due, upcoming } = response.data.message.reminder;

          // Deduplicate each bucket by lead key — the API returns one row per reminder_id,
          // so the same lead can appear multiple times per bucket.
          const dedup = (arr: any[]) =>
            Array.from(
              new Map(arr.map((l: any) => [Number(l.key), l])).values(),
            );
          const todayUniq = dedup(today || []);
          const overdueUniq = dedup(due || []);
          const upcomingUniq = dedup(upcoming || []);

          setReminderLeadIds({
            today: todayUniq.map((l: any) => Number(l.key)),
            overdue: overdueUniq.map((l: any) => Number(l.key)),
            upcoming: upcomingUniq.map((l: any) => Number(l.key)),
          });
          setReminderLeads({
            today: todayUniq,
            overdue: overdueUniq,
            upcoming: upcomingUniq,
          });
          reminderLoadedForFormRef.current = formDataFormChoose.form_id;
        } else {
          setReminderLeadIds(null);
          setReminderLeads(null);
        }
      } catch (error) {
        console.error("Error fetching reminder lead IDs:", error);
        setReminderLeadIds(null);
        setReminderLeads(null);
      } finally {
        setIsReminderLoading(false);
        setReminderDropdownOpened(false); // reset trigger after fetch
      }
    };

    fetchReminderLeadIds();
  }, [
    reminderDropdownOpened,
    formDataFormChoose.form_id,
    formDataCompanyChoose.companyId,
    formDataCompanyChoose.companyType,
    signature,
  ]);

  const fetchCompanies = async () => {
    try {
      setIsInitializing(true);
      const response = await api.post("userService/getAllCompanyList", {
        signature,
      });
      setgetAllCompanyList(response.data.data.data || []);
    } catch (error) {
      console.error("Error fetching companies:", error);
      showBasicAlert("Failed to load companies");
    } finally {
      setIsInitializing(false);
    }
  };

  const fetchForms = async () => {
    try {
      setIsLoadingData(true);
      const response = await api.post("leadService/getLeadFormsByCompany", {
        signature,
        company_id: formDataCompanyChoose.companyId,
        company_type: formDataCompanyChoose.companyType,
      });
      setdataForm(response.data.data.data || []);
    } catch (error) {
      console.error("Error fetching forms:", error);
      showBasicAlert("Failed to load forms");
      setdataForm([]);
    } finally {
      setIsLoadingData(false);
    }
  };

  const fetchLeads = async () => {
    if (!formDataFormChoose.form_id || !formDataFormChoose.pipeline_id) return;

    // Prevent duplicate API calls
    const fetchParams = JSON.stringify({
      companyId: formDataCompanyChoose.companyId,
      formId: formDataFormChoose.form_id,
      userId: formDataFormChoose.user_id,
      pipelineValue: formDataFormChoose.pipeline_value,
      source: selectedLeadSource,
      start: selectedStartDate.format("YYYY-MM-DD"),
      end: selectedEndDate.format("YYYY-MM-DD"),
    });

    if (prevFetchParamsRef.current === fetchParams) return;
    prevFetchParamsRef.current = fetchParams;

    try {
      setIsLoadingData(true);

      const [pipelineRes, leadsRes, settingsRes] = await Promise.all([
        api.post("leadService/getAllPipelinesById", {
          signature,
          id: formDataFormChoose.pipeline_id,
        }),
        api.post("leadService/getAllLeadsResponse", {
          signature,
          company_id: formDataCompanyChoose.companyId,
          company_type: formDataCompanyChoose.companyType,
          start_date: selectedStartDate.format("YYYY-MM-DD"),
          end_date: selectedEndDate.format("YYYY-MM-DD"),
          form_id: formDataFormChoose.form_id,
          ...(formDataFormChoose.user_id !== "0" && {
            user_id: formDataFormChoose.user_id,
          }),
          ...(formDataFormChoose.pipeline_value !== "0" && {
            pipeline_char: formDataFormChoose.pipeline_char,
          }),
          ...getLeadSourceFilter(),
        }),
        api.post("leadService/getAllLeadSettings", {
          signature,
          company_id: parseInt(formDataCompanyChoose.companyId),
          company_type: formDataCompanyChoose.companyType,
        }),
      ]);

      const stages = pipelineRes.data.data.data || [];
      const fetchedLeads = leadsRes.data.data.data || [];
      const fetchedTransferLeadsId = leadsRes.data.data.transferLeadIds || [];

      setTransferLeadsId(fetchedTransferLeadsId);
      setPipelines(stages);

      // ✅ Fetch users only once
      if (users.length === 0) {
        const userRes = await api.post("userService/getLeadEmployeesListData", {
          signature,
          department:
            settingsRes?.data?.data?.data[0]?.settings
              ?.lead_assigned_to_department || -1,
          company_id: parseInt(formDataCompanyChoose.companyId),
          company_type: formDataCompanyChoose.companyType,
        });
        setUsers(userRes.data?.data?.data?.allUsers || []);
      }

      // Filter leads by pipeline
      const filteredLeads = fetchedLeads.filter(
        (item: any) =>
          parseInt(item.pipeline_id) ===
          parseInt(formDataFormChoose.pipeline_id),
      );

      setData(filteredLeads);
      setFilteredData(filteredLeads);
      setLastLeadDeail(
        Array.isArray(fetchedLeads) && fetchedLeads[0] ? fetchedLeads : [],
      );

      // ✅ Set header stats
      const items = fetchedLeads[0]?.Items || {
        "Total Leads": 0,
        "Today's Leads": 0,
        "Yesterday's Leads": 0,
        "This Month's Leads": 0,
      };

      const statsConfig: any = {
        "Total Leads": { icon: "ti-stack-middle", color: "bg-primary" },
        "Today's Leads": { icon: "ti-calendar", color: "bg-success" },
        "Yesterday's Leads": { icon: "ti-calendar-event", color: "bg-warning" },
        "This Month's Leads": { icon: "ti-calendar-month", color: "bg-info" },
      };

      const stats = Object.entries(items).map(([key, value]: any) => ({
        title: key,
        value,
        icon: statsConfig[key]?.icon || "ti-briefcase",
        color: statsConfig[key]?.color || "bg-secondary",
      }));

      setHeaderGrid(stats);

      // Update company list for add modal
      const filteredCompanies = getAllCompanyLists.filter(
        (c) =>
          c.id === Number(formDataCompanyChoose.companyId) &&
          c.type === formDataCompanyChoose.companyType,
      );
      setgetAllCompanyListForAdd(filteredCompanies);
    } catch (error) {
      console.error("Error fetching leads:", error);
      showBasicAlert("Failed to load leads");
    } finally {
      setIsLoadingData(false);
    }
  };

  // ========== HANDLERS ==========

  const handleCompanyChange = (selectedOption: any) => {
    if (!selectedOption?.value) return;
    setformDataCompanyChoose({
      companyId: selectedOption.value,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: selectedOption.label.split("-")[1].trim(),
    });
  };

  const handleFormChange = (selectedOption: any) => {
    if (!selectedOption?.value) {
      setformDataFormChoose((prev: any) => ({
        ...prev,
        pipeline_id: "",
        form_name: selectedOption?.label || "No Lead Form",
        form_id: "",
      }));
      return;
    }
    setformDataFormChoose((prev: any) => ({
      ...prev,
      pipeline_id: selectedOption.value?.split("-")[0],
      form_name: selectedOption.label,
      form_id: selectedOption.value?.split("-")[1],
    }));
  };

  const handleUserChange = (selectedOption: any) => {
    if (!selectedOption?.value) return;
    setformDataFormChoose((prev) => ({
      ...prev,
      user_id: selectedOption.value,
      user_name: selectedOption.label,
    }));
  };

  const handlePipelineChange = (selectedOption: any) => {
    if (!selectedOption) return;
    setformDataFormChoose((prev: any) => ({
      ...prev,
      pipeline_value: selectedOption.value,
      pipeline_char: selectedOption.label,
    }));
  };

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };

  const handleLeadSourceChange = (value: string) => {
    setSelectedLeadSource(value);
  };

  const handleClearLeadSource = () => {
    isRestoringFromPreserve.current = false;
    locationStateRef.current = null;

    setSelectedLeadSource(undefined);
    setSelectedStartDate(moment().subtract(29, "days"));
    setSelectedEndDate(moment());
    setFollowUpFilter("all");
    setCustomFollowUpDate(null);
    setShowOnlyTransferred(false);
    setActivityFilter("all");
    setActivityStartDate(moment().subtract(29, "days"));
    setActivityEndDate(moment());
    setActivityLeadIds(null);
    setSearchQuery("");
    setTempSearchQuery("");
    setSearchInput("");
    setSortBy("Recently Added");
    setFilterKey((prev) => prev + 1);
    prevFetchParamsRef.current = "";

    if (
      user?.userDetails.role_char.toLowerCase() === "admin" ||
      user?.userDetails.role_char.toLowerCase() === "employeeadmin"
    ) {
      setformDataFormChoose((prev) => ({
        ...prev,
        user_id: "0",
        user_name: "All Employees",
        pipeline_value: "0",
        pipeline_char: "All Pipelines",
      }));
    }

    setTimeout(() => {
      isRestoringFromPreserve.current = false;
    }, 100);
  };

  const forceRefreshLeads = useCallback(() => {
    prevFetchParamsRef.current = "";
    fetchLeads();
  }, [fetchLeads]);

  const handleStageChange = async (value: any, record: any) => {
    const activePipeline = pipelines.find(
      (p: any) => parseInt(p.key) === parseInt(formDataFormChoose.pipeline_id),
    );
    const stageConf =
      (activePipeline?.Stages_Config || []).find(
        (c: any) =>
          c.stage_name?.toLowerCase().trim() === value.toLowerCase().trim(),
      ) || {};
    const shouldShowReminder = stageConf.require_reminder !== false;

    try {
      await api.post("leadService/updateLeadResponsePipeline", {
        signature,
        pipeline: value,
        lead_id: record.key,
      });

      if (!shouldShowReminder) {
        fetchLeads();
      } else {
        setSelectedLeadId(record.key);
        setShowReminderModal(true);
      }
    } catch (err) {
      console.error("Error updating lead pipeline:", err);
      showBasicAlert("Failed to update pipeline");
      fetchLeads();
    }
  };

  const handleReminderSubmit = async () => {
    if (selectedReminderDate && selectedLeadId) {
      try {
        const lead: any = filteredData.find(
          (l: any) => String(l.key) === selectedLeadId,
        );

        await api.post("leadService/addLeadFollowUp", {
          signature,
          lead_id: selectedLeadId,
          company_id: lead?.company_id || formDataCompanyChoose.companyId,
          company_type: lead?.company_type || formDataCompanyChoose.companyType,
          follow_up_date: selectedReminderDate,
        });

        showBasicAlert("Follow-up reminder added successfully");
      } catch (e: any) {
        showBasicAlert(e.data?.message?.[0]?.msg || "Failed to add reminder");
      }
    }

    setShowReminderModal(false);
    setSelectedReminderDate(null);
    setSelectedLeadId(null);
    fetchLeads();
  };

  const handleReminderSkip = () => {
    setShowReminderModal(false);
    setSelectedReminderDate(null);
    setSelectedLeadId(null);
    fetchLeads();
  };

  const handleMenuOpen = (event: any, lead: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedLead(lead);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditLead = () => {
    setIsEditOpen(true);
    handleMenuClose();
  };

  const handleCloseEdit = () => {
    fetchLeads();
    setIsEditOpen(false);
  };

  const refreshPage = () => {
    forceRefreshLeads();
  };

  // ✅ Client-side filtering and sorting
  // Update this useEffect
  useEffect(() => {
    if (
      data.length > 0 ||
      (reminderLeads &&
        ["today", "overdue", "upcoming", "custom"].includes(followUpFilter))
    ) {
      let newFilteredData = [...data];

      const role = user?.userDetails?.role_char?.toLowerCase();
      const isAdmin = role === "admin" || role === "employeeadmin";
      const isReminderFilterActive = [
        "today",
        "overdue",
        "upcoming",
        "custom",
      ].includes(followUpFilter);

      if (isReminderFilterActive && reminderLeads) {
        if (followUpFilter === "today") {
          newFilteredData = [...reminderLeads.today];
        } else if (followUpFilter === "overdue") {
          newFilteredData = [...reminderLeads.overdue];
        } else if (followUpFilter === "upcoming") {
          newFilteredData = [...reminderLeads.upcoming];
        } else if (followUpFilter === "custom") {
          const allReminders = [
            ...(reminderLeads.today || []),
            ...(reminderLeads.overdue || []),
            ...(reminderLeads.upcoming || []),
          ];
          if (!reminderCustomStart || !reminderCustomEnd) {
            newFilteredData = allReminders;
          } else {
            newFilteredData = allReminders.filter((lead: any) => {
              const followUpDate = lead.follow_up_date;
              if (!followUpDate) return false;
              const leadMomentCheck = moment(followUpDate).local();
              return (
                leadMomentCheck.isSameOrAfter(reminderCustomStart, "day") &&
                leadMomentCheck.isSameOrBefore(reminderCustomEnd, "day")
              );
            });
          }
          const uniqueReminders = new Map(
            newFilteredData.map((item: any) => [item.key || item.id, item]),
          );
          newFilteredData = Array.from(uniqueReminders.values());
        }
      } else {
        // Apply follow-up filter
        newFilteredData = newFilteredData.filter(filterByFollowUp);
      }

      if (
        isReminderFilterActive &&
        reminderLeads &&
        formDataFormChoose.user_id &&
        formDataFormChoose.user_id !== "0"
      ) {
        newFilteredData = newFilteredData.filter(
          (lead: any) =>
            String(lead.assigned_to) === String(formDataFormChoose.user_id),
        );
      }

      if (activityLeadIds !== null) {
        newFilteredData = newFilteredData.filter((lead: any) =>
          activityLeadIds.includes(Number(lead.key || lead.id)),
        );
      }

      if (formDataFormChoose.pipeline_value !== "0") {
        newFilteredData = newFilteredData.filter(
          (lead: any) =>
            lead.pipeline_char === formDataFormChoose.pipeline_char,
        );
      }

      if (showOnlyTransferred) {
        newFilteredData = newFilteredData.filter((lead: any) =>
          transferLeadsId.includes(lead.lead_id),
        );
      }

      if (searchQuery) {
        newFilteredData = newFilteredData.filter(
          (lead: any) =>
            lead.response?.["Full Name"]
              ?.toLowerCase()
              .includes(searchQuery.toLowerCase()) ||
            lead.mobile_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            lead?.email?.toLowerCase().includes(searchQuery.toLowerCase()),
        );
      }

      // Apply sorting
      newFilteredData.sort((a: any, b: any) => {
        switch (sortBy) {
          case "Recently Added":
            return (
              new Date(b.CreatedDate).getTime() -
              new Date(a.CreatedDate).getTime()
            );
          case "Ascending(Company)":
            return (a.CompanyName || "").localeCompare(b.CompanyName || "");
          case "Descending(Company)":
            return (b.CompanyName || "").localeCompare(a.CompanyName || "");
          case "Ascending(Name)":
            return (a.LeadName || "").localeCompare(b.LeadName || "");
          case "Descending(Name)":
            return (b.LeadName || "").localeCompare(a.LeadName || "");
          case "Last Month":
            return (
              new Date(b.CreatedDate).getTime() -
              new Date(a.CreatedDate).getTime()
            );
          case "Last 7 Days":
            return (
              new Date(b.CreatedDate).getTime() -
              new Date(a.CreatedDate).getTime()
            );
          default:
            return (
              new Date(b.CreatedDate).getTime() -
              new Date(a.CreatedDate).getTime()
            );
        }
      });

      setFilteredData(newFilteredData);
    }
  }, [
    sortBy,
    data,
    filterByFollowUp,
    searchQuery,
    showOnlyTransferred,
    transferLeadsId,
    activityLeadIds,
    followUpFilter,
    reminderLeads,
    reminderCustomStart,
    reminderCustomEnd,
    formDataFormChoose.pipeline_value,
    formDataFormChoose.pipeline_char,
    formDataFormChoose.user_id,
  ]);

  // ========== EXPORT FUNCTIONS ==========

  const handleExportPDF = () => {
    const doc = new jsPDF();
    const columns = [
      "Lead Name",
      "Company Type",
      "Phone",
      "Email",
      "Stage",
      "Date",
      "Lead Owner",
    ];
    const tableData: (string | number)[][] = filteredData.map((item) => [
      item.LeadName,
      item.CompanyName,
      item.Phone,
      item.Email,
      item.pipeline_char,
      item.createdAt,
      item.LeadName,
    ]);
    console.log("Data: ", filteredData?.[0]);
    doc.autoTable({ head: [columns], body: tableData });
    doc.save("leads.pdf");
  };

  const handleExportExcel = () => {
    const removeKeys = [
      "key",
      "form_id",
      "company_id",
      "company_type",
      "Phone",
      "Logo",
      "assigned_to",
      "status",
      "pipeline_id",
      "CompanyName",
      "Pipeline",
      "Items",
      "createdAt",
    ];

    const transformedData = filteredData.map((item) => {
      const newObj: any = {};
      Object.keys(item).forEach((key) => {
        if (!removeKeys.includes(key)) {
          const formattedKey: any = formatHeader(key);
          newObj[formattedKey] = item[key];
        }
      });
      const leadResponse = item.response || {};
      newObj["City"] = leadResponse["City"] || "";
      newObj["District"] = leadResponse["District"] || "";
      newObj["State"] = leadResponse["State"] || "";
      return newObj;
    });

    const ws = XLSX.utils.json_to_sheet(transformedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Leads");
    XLSX.writeFile(wb, "leads.xlsx");
  };

  const formatHeader = (key: any) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char: any) => char.toUpperCase());
  };

  // ========== COMPUTED VALUES ==========

  const companyChoose = useMemo(
    () =>
      getAllCompanyLists.map((c: any) => ({
        value: c.id,
        label: `${c.name} - ${c.type}`,
      })),
    [getAllCompanyLists],
  );

  const formChoose = useMemo(
    () =>
      dataForm.map((f: any) => ({
        value: `${f.pipeline_id}-${f.key}`,
        label: f.LeadFormName,
      })),
    [dataForm],
  );

  const userChoose = useMemo(() => {
    const selectedForm = dataForm.find(
      (f) => String(f.key) === String(formDataFormChoose.form_id),
    );

    if (!selectedForm) {
      return [
        { value: "0", label: "All Employees" },
        ...users.map((u: any) => ({ value: u.key, label: u.Name })),
      ];
    }

    const hasEmployees =
      selectedForm.employees &&
      Array.isArray(selectedForm.employees) &&
      selectedForm.employees.length > 0;

    if (!hasEmployees) {
      return [
        { value: "0", label: "All Employees" },
        ...users.map((u: any) => ({ value: u.key, label: u.Name })),
      ];
    }

    const filteredUsers = users.filter((user: any) =>
      selectedForm.employees.includes(user.key),
    );

    return [
      { value: "0", label: "All Employees" },
      ...filteredUsers.map((u: any) => ({ value: u.key, label: u.Name })),
    ];
  }, [users, dataForm, formDataFormChoose.form_id]);

  const pipelineFilterChoose = useMemo(
    () => [
      { value: "0", label: "All Pipelines" },
      ...(Array.isArray(pipelines?.[0]?.Stages)
        ? pipelines[0].Stages.map((pipe: any) => ({ value: pipe, label: pipe }))
        : []),
    ],
    [pipelines],
  );

  const isPageLoading = useMemo(() => isInitializing, [isInitializing]);

  // ========== TABLE COLUMNS ==========

  const columns = [
    {
      title: "Lead Name",
      dataIndex: "LeadName",
      render: (text: string, record: any) => {
        const filteredPipelines = pipelines.filter(
          (item: any) =>
            item.Company_Type?.trim() === record.company_type?.trim() &&
            parseInt(item.Company_Id) === parseInt(record.company_id) &&
            item.Type === "lead",
        );
        const stages = filteredPipelines?.[0]?.Stages || [];
        const stagesConfig = filteredPipelines?.[0]?.Stages_Config || [];
        return (
          <h6 className="fw-medium fs-14">
            <Link
              to={`${routes.leadsDetails}${location?.search}`}
              state={{
                lead: record,
                data: dataForm,
                pipelines: stages,
                pipelinesConfig: stagesConfig,
                type: "lead_list",
                selectedCompanyDetails: formDataCompanyChoose,
                selectedLeadFormDetails: formDataFormChoose,
                preserveFilters: {
                  companyId: formDataCompanyChoose.companyId,
                  companyName: formDataCompanyChoose.companyName,
                  companyType: formDataCompanyChoose.companyType,
                  pipeline_id: formDataFormChoose.pipeline_id,
                  form_name: formDataFormChoose.form_name,
                  form_id: formDataFormChoose.form_id,
                  user_id: formDataFormChoose.user_id,
                  user_name: formDataFormChoose.user_name,
                  pipeline_value: formDataFormChoose.pipeline_value,
                  pipeline_char: formDataFormChoose.pipeline_char,
                  selectedLeadSource: selectedLeadSource,
                  selectedStartDate: selectedStartDate.format("YYYY-MM-DD"),
                  selectedEndDate: selectedEndDate.format("YYYY-MM-DD"),
                  sortBy: sortBy,
                  followUpFilter: followUpFilter,
                  customFollowUpDate: customFollowUpDate
                    ? customFollowUpDate.format("YYYY-MM-DD")
                    : null,
                  showOnlyTransferred: showOnlyTransferred,
                  activityFilter: activityFilter,
                  activityStartDate: activityStartDate.format("YYYY-MM-DD"),
                  activityEndDate: activityEndDate.format("YYYY-MM-DD"),
                  searchQuery: searchQuery,
                  searchInput: searchInput,
                  tempSearchQuery: tempSearchQuery,
                  showFilters: showFilters,
                },
              }}
            >
              {text}
            </Link>
          </h6>
        );
      },
      sorter: (a: any, b: any) => a.LeadName.length - b.LeadName.length,
    },
    {
      title: "Phone",
      dataIndex: "Phone",
    },
    {
      title: "Pipeline",
      dataIndex: "Pipeline",
      sorter: (a: any, b: any) => {
        if (a.pipeline_char < b.pipeline_char) return -1;
        if (a.pipeline_char > b.pipeline_char) return 1;
        return 0;
      },
      render: (text: any, record: any) => {
        const currentColor =
          pipelines[0]?.Color?.[
            pipelines[0]?.Stages?.indexOf(record.pipeline_char)
          ] || "#000000";

        return (
          <Select
            defaultValue={record.pipeline_char}
            onChange={(value: any) => handleStageChange(value, record)}
            style={{
              width: 150,
              backgroundColor: currentColor,
              border: `3px solid ${currentColor}`,
              color: "#fff",
              paddingLeft: "24px",
              position: "relative",
            }}
            dropdownStyle={{ backgroundColor: "#fff" }}
          >
            {text.map((stage: any) => (
              <Option key={stage} value={stage}>
                <span className="badge-info-transparent">{stage}</span>
              </Option>
            ))}
          </Select>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "CreatedDate",
      render: (value: string) => {
        return (
          <span style={{ display: "flex", flexDirection: "column" }}>
            {humanReadableDate(value, true, undefined, undefined, false)}
          </span>
        );
      },
      sorter: (a: any, b: any) =>
        new Date(a.CreatedDate).getTime() - new Date(b.CreatedDate).getTime(),
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to_name",
      sorter: (a: any, b: any) =>
        a.assigned_to_name.length - b.assigned_to_name.length,
    },
    {
      title: "More Detail",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const filteredPipelines = pipelines.filter(
          (item: any) =>
            item.Company_Type?.trim() === record.company_type?.trim() &&
            parseInt(item.Company_Id) === parseInt(record.company_id) &&
            item.Type === "lead",
        );
        const stages = filteredPipelines?.[0]?.Stages || [];
        const stagesConfig = filteredPipelines?.[0]?.Stages_Config || [];
        return (
          <h6 className="fw-medium fs-14">
            <Link
              to={`${routes.leadsDetails}${location?.search}`}
              state={{
                lead: record,
                data: dataForm,
                pipelines: stages,
                pipelinesConfig: stagesConfig,
                type: "lead_list",
                selectedCompanyDetails: formDataCompanyChoose,
                selectedLeadFormDetails: formDataFormChoose,
                preserveFilters: {
                  companyId: formDataCompanyChoose.companyId,
                  companyName: formDataCompanyChoose.companyName,
                  companyType: formDataCompanyChoose.companyType,
                  pipeline_id: formDataFormChoose.pipeline_id,
                  form_name: formDataFormChoose.form_name,
                  form_id: formDataFormChoose.form_id,
                  user_id: formDataFormChoose.user_id,
                  user_name: formDataFormChoose.user_name,
                  pipeline_value: formDataFormChoose.pipeline_value,
                  pipeline_char: formDataFormChoose.pipeline_char,
                  selectedLeadSource: selectedLeadSource,
                  selectedStartDate: selectedStartDate.format("YYYY-MM-DD"),
                  selectedEndDate: selectedEndDate.format("YYYY-MM-DD"),
                  sortBy: sortBy,
                  followUpFilter: followUpFilter,
                  customFollowUpDate: customFollowUpDate
                    ? customFollowUpDate.format("YYYY-MM-DD")
                    : null,
                  showOnlyTransferred: showOnlyTransferred,
                  activityFilter: activityFilter,
                  activityStartDate: activityStartDate.format("YYYY-MM-DD"),
                  activityEndDate: activityEndDate.format("YYYY-MM-DD"),
                  searchQuery: searchQuery,
                  searchInput: searchInput,
                  tempSearchQuery: tempSearchQuery,
                  showFilters: showFilters,
                },
              }}
              className="text-decoration-underline"
            >
              Click here
            </Link>
          </h6>
        );
      },
    },
    {
      title: "Edit",
      render: (text: string, lead: any) => {
        return (
          <div className="ms-auto">
            <IconButton
              aria-label="edit"
              onClick={(event) =>
                handleMenuOpen(event, {
                  structure: dataForm.find(
                    (item) => parseInt(item.key) === parseInt(lead.form_id),
                  )?.structure,
                  responses: lead.response,
                  id: lead.key,
                })
              }
            >
              <EditIcon fontSize="small" />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleEditLead}>Edit Lead</MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1 d-flex align-items-center">👤 Leads</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">CRM</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leads List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="mb-2">
                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  <Link
                    to={`${routes.leadsList}${location?.search}`}
                    className="btn btn-icon btn-sm active bg-primary text-white me-1"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={`${routes.leadsGrid}${location?.search}`}
                    state={{
                      companyDetails: formDataCompanyChoose,
                      formDetails: formDataFormChoose,
                    }}
                    className="btn btn-icon btn-sm"
                  >
                    <i className="ti ti-layout-grid" />
                  </Link>
                </div>
              </div>
              <div className="dropdown me-1 mb-2" style={{ maxWidth: "180px" }}>
                <CommonSelect
                  className="select"
                  options={formChoose}
                  defaultValue={{
                    value: `${formDataFormChoose.pipeline_id}-${formDataFormChoose.form_id}`,
                    label: formDataFormChoose.form_name,
                  }}
                  onChange={handleFormChange}
                />
              </div>
              <div className="dropdown me-1 mb-2" style={{ maxWidth: "200px" }}>
                <CommonSelect
                  className="select"
                  options={companyChoose}
                  defaultValue={{
                    value: formDataCompanyChoose.companyId,
                    label: `${formDataCompanyChoose.companyName}-${formDataCompanyChoose.companyType}`,
                  }}
                  onChange={handleCompanyChange}
                />
              </div>
              <div
                className="dropdown me-1 mb-2"
                style={{ position: "relative", maxWidth: "140px" }}
              >
                <ReminderDropdown
                  followUpFilter={followUpFilter}
                  setFollowUpFilter={setFollowUpFilter}
                  reminderLeadIds={reminderLeadIds}
                  isReminderLoading={isReminderLoading}
                  reminderCustomStart={reminderCustomStart}
                  reminderCustomEnd={reminderCustomEnd}
                  setReminderCustomStart={setReminderCustomStart}
                  setReminderCustomEnd={setReminderCustomEnd}
                  onOpen={() => setReminderDropdownOpened(true)}
                />
              </div>
              {user?.userDetails?.role_char?.toLowerCase() !== "employee" && (
                <div className="me-1 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      onClick={(e: any) => e.preventDefault()}
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          onClick={(e: any) => {
                            e.preventDefault();
                            handleExportPDF();
                          }}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            handleExportExcel();
                          }}
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              <div className="mb-2 me-1">
                {formDataFormChoose.form_name === "No Lead Form" ? (
                  <button
                    className="btn btn-primary d-flex align-items-center p-2"
                    disabled
                  >
                    <i className="ti ti-circle-plus me-1" />
                    Add Lead
                  </button>
                ) : (
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    data-bs-toggle="modal"
                    data-bs-target="#add_leads"
                    className="btn btn-primary d-flex align-items-center p-2"
                  >
                    <i className="ti ti-circle-plus me-1" />
                    Add Lead
                  </Link>
                )}
              </div>
              <div className="mb-2 d-flex align-items-center gap-2">
                <button
                  onClick={() => setShowFilters((v) => !v)}
                  style={{
                    height: "38px",
                    padding: "0 18px",
                    borderRadius: "999px",
                    border: "1.5px solid #dbeafe",
                    background: "#e8f1fc",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#232360",
                    whiteSpace: "nowrap",
                    transition: "background 0.2s ease",
                  }}
                >
                  <SlidersHorizontal size={16} />
                  {showFilters ? "Hide Filters" : "Show Filters"}
                  {activeFilterCount > 0 && (
                    <span
                      className="badge bg-primary rounded-circle ms-1"
                      style={{ fontSize: "10px", padding: "4px 6px" }}
                    >
                      {activeFilterCount}
                    </span>
                  )}
                </button>
                {activeFilterCount > 0 && (
                  <button
                    onClick={handleClearAllFilters}
                    className="btn btn-outline-danger d-flex align-items-center gap-1"
                    style={{
                      height: "38px",
                      padding: "0 15px",
                      borderRadius: "999px",
                      fontWeight: 500,
                      fontSize: "14px",
                    }}
                  >
                    <i className="ti ti-trash fs-16" />
                    Clear
                  </button>
                )}
              </div>
              <div className="head-icons ms-1">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                background: "#f1f3ff",
                border: "1px solid #dbe4ff",
                borderLeft: "4px solid #3b5bdb",
                padding: "10px 14px",
                borderRadius: "8px",
                fontSize: "13px",
                color: "#2b2f36",
                lineHeight: 1.5,
              }}
            >
              <i
                className="ti ti-info-circle"
                style={{
                  fontSize: "16px",
                  color: "#3b5bdb",
                  marginTop: "2px",
                }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ color: "#495057" }}>
                  Showing data from{" "}
                  <span style={{ fontWeight: 500, color: "#3b5bdb" }}>
                    {selectedStartDate.format("DD MMM YYYY")}
                  </span>{" "}
                  to{" "}
                  <span style={{ fontWeight: 500, color: "#3b5bdb" }}>
                    {selectedEndDate.format("DD MMM YYYY")}
                  </span>
                </span>
              </div>
            </div>
          </div>

          {/* Leads List */}

          {isPageLoading || isLoadingData ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "400px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading leads data...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="livecall-layout align-top">
                <div className="livecall-table-section">
                  <div className=" p-0">
                    <div>
                      <div className="row">
                        {filteredData.length > 0 &&
                          HeaderGrid.map((stat: any, index: any) => (
                            <div className="col-xl-3 col-md-6" key={index}>
                              <div
                                className="card position-relative border-0 shadow-sm h-60"
                                style={{
                                  borderRadius: "12px",
                                  overflow: "hidden",
                                  transition: "all 0.3s",
                                }}
                              >
                                <div className="card-body position-relative z-1 bg-white">
                                  <div className="d-flex align-items-center mb-3">
                                    <div
                                      className={`avatar avatar-md rounded-circle d-flex align-items-center justify-content-center ${stat.color}`}
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        boxShadow:
                                          "0 4px 12px rgba(0, 0, 0, 0.1)",
                                      }}
                                    >
                                      <i
                                        className={`ti ${stat.icon} text-white fs-20`}
                                      />
                                    </div>
                                    <div className="ms-3">
                                      <p className="fw-semibold text-muted mb-1 text-truncate">
                                        {stat.title}
                                      </p>
                                      <h5 className="mb-0 fw-bold text-dark">
                                        {stat.value}
                                      </h5>
                                    </div>
                                  </div>
                                  <span
                                    className="position-absolute top-0 end-0 opacity-10"
                                    style={{ zIndex: 0 }}
                                  >
                                    <ImageWithBasePath
                                      src="assets/img/bg/card-bg-04.png"
                                      alt="bg"
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="card">
                      <Table
                        key={JSON.stringify(filteredData)}
                        dataSource={filteredData}
                        columns={columns}
                        Selection={false}
                      />
                    </div>
                  </div>
                </div>

                {/* Filter Sidebar */}
                <div
                  className={`slide-in-left livecall-filters-section${showFilters ? "" : " hidden"}`}
                >
                  <LeadsGridFilters
                    showFilters={showFilters}
                    userRole={user?.userDetails.role_char.toLowerCase()}
                    userChoose={userChoose}
                    followUpOptions={followUpOptions}
                    activityFilterOptions={activityFilterOptions}
                    formDataFormChoose={formDataFormChoose}
                    followUpFilter={followUpFilter}
                    customFollowUpDate={customFollowUpDate}
                    activityFilter={activityFilter}
                    activityStartDate={activityStartDate}
                    activityEndDate={activityEndDate}
                    sortBy={sortBy}
                    selectedStartDate={selectedStartDate}
                    selectedEndDate={selectedEndDate}
                    searchQuery={searchQuery}
                    tempSearchQuery={tempSearchQuery}
                    isActivityLoading={isActivityLoading}
                    activeFilterCount={activeFilterCount}
                    showOnlyTransferred={showOnlyTransferred}
                    selectedLeadSource={selectedLeadSource}
                    leadSource={leadSource}
                    setShowOnlyTransferred={setShowOnlyTransferred}
                    handleLeadSourceChange={handleLeadSourceChange}
                    handleUserChange={handleUserChange}
                    setFollowUpFilter={setFollowUpFilter}
                    setCustomFollowUpDate={setCustomFollowUpDate}
                    handleActivityFilterChange={handleActivityFilterChange}
                    handleActivityDateChange={handleActivityDateChange}
                    setSortBy={setSortBy}
                    handleDateChange={handleDateChange}
                    setTempSearchQuery={setTempSearchQuery}
                    handleSearchApply={handleSearchApply}
                    handleResetFilters={handleClearAllFilters}
                    showPipeline={true}
                    pipelineFilterChoose={pipelineFilterChoose}
                    pipelineValue={formDataFormChoose.pipeline_value}
                    pipelineChar={formDataFormChoose.pipeline_char}
                    handlePipelineChange={handlePipelineChange}
                  />
                </div>
              </div>
            </>
          )}
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link
              to="#"
              onClick={(e: any) => e.preventDefault()}
              className="text-primary"
            >
              ZYVO
            </Link>
          </p>
        </div>
      </div>

      {dataForm.length > 0 && (
        <AddLeads
          companyList={getAllCompanyListsForAdd}
          formsList={dataForm}
          users={users}
          lastLeadData={lastLeadDetail}
          refreshPage={refreshPage}
        />
      )}

      {selectedLead && (
        <EditLead
          open={isEditOpen}
          onClose={handleCloseEdit}
          updateUI={() => {
            setIsEditOpen(false);
            forceRefreshLeads();
          }}
          data={[selectedLead]}
        />
      )}

      <Dialog open={showReminderModal} maxWidth="sm" fullWidth>
        <DialogTitle>
          Add Follow-Up Reminder
          <Typography variant="body2" color="text.secondary">
            Set a reminder for this lead after moving to new stage
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DatePicker
            className="form-control datetimepicker w-100 mt-3"
            format="DD-MM-YYYY HH:mm"
            showTime={{ format: "HH:mm" }}
            onChange={(date: any) => setSelectedReminderDate(date)}
            placeholder="Select reminder date and time"
            disabledDate={(current: any) =>
              !!current && current.valueOf() < new Date().setHours(0, 0, 0, 0)
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleReminderSubmit}
            variant="contained"
            disabled={!selectedReminderDate}
          >
            Save Reminder
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LeadsList;
